const UPDATE_ITEMS = [
  {
    time: '刚刚',
    title: '某顶流男星律师发表声明：将对造谣者追究法律责任',
    desc: '声明强调网络不是法外之地，已委托律师事务所收集证据，将起诉多个造谣账号。',
    icon: 'ri-megaphone-line',
    iconBg: 'bg-primary-500/15 text-primary-400',
  },
  {
    time: '15分钟前',
    title: '综艺节目制作方回应黑幕指控：正在内部调查',
    desc: '制作公司发布公告称高度重视选手反馈，已成立专项调查组，承诺一周内公布结果。',
    icon: 'ri-file-text-line',
    iconBg: 'bg-accent-500/15 text-accent-400',
  },
  {
    time: '38分钟前',
    title: '品牌方连夜下架涉事艺人全部宣传物料',
    desc: '多个电商平台和线下门店已撤下相关代言海报，品牌官网删除合作艺人信息。',
    icon: 'ri-delete-back-line',
    iconBg: 'bg-secondary-500/15 text-secondary-400',
  },
  {
    time: '1小时前',
    title: '粉丝后援会发布声明：暂停一切应援活动',
    desc: '后援会表示将等待事件真相查明后再决定后续行动，呼吁粉丝理性对待。',
    icon: 'ri-group-line',
    iconBg: 'bg-primary-500/15 text-primary-400',
  },
  {
    time: '2小时前',
    title: '知情人二次爆料：更多聊天记录截图流出',
    desc: '新一批截图涉及多位圈内人士，91黑料吃瓜网持续跟进报道最新进展。',
    icon: 'ri-image-line',
    iconBg: 'bg-accent-500/15 text-accent-400',
  },
  {
    time: '3小时前',
    title: '税务部门回应：已收到举报材料，将依法核查',
    desc: '相关人士透露举报材料详实，如属实将面临严厉处罚。吃瓜黑料网将持续关注。',
    icon: 'ri-government-line',
    iconBg: 'bg-secondary-500/15 text-secondary-400',
  },
  {
    time: '5小时前',
    title: '圈内人士匿名采访：这行水很深，这只是冰山一角',
    desc: '资深经纪人匿名接受采访，透露娱乐圈更多不为人知的运作内幕。',
    icon: 'ri-chat-quote-line',
    iconBg: 'bg-primary-500/15 text-primary-400',
  },
  {
    time: '8小时前',
    title: '行业协会表态：将加强艺人职业道德建设',
    desc: '相关协会发文强调将完善行业规范，对失德艺人实行联合抵制机制。',
    icon: 'ri-building-line',
    iconBg: 'bg-accent-500/15 text-accent-400',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-900">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            <i className="ri-flashlight-line text-primary-400 mr-2"></i>
            最新快讯
          </h2>
          <p className="mt-2 text-sm text-foreground-500">24小时滚动更新，黑料吃瓜爆料不停</p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-5 md:left-6 top-0 bottom-0 w-px bg-background-700/60"></div>

          <div className="space-y-6 md:space-y-8">
            {UPDATE_ITEMS.map((item, i) => (
              <div key={i} className="relative pl-12 md:pl-14">
                {/* Timeline dot */}
                <div className={`absolute left-3 md:left-[22px] w-4 h-4 rounded-full border-2 border-background-900 ${item.iconBg} flex items-center justify-center z-10`}>
                  <div className="w-2 h-2 rounded-full bg-current opacity-60"></div>
                </div>

                {/* Content */}
                <div className="p-4 md:p-5 rounded-xl bg-background-800/30 border border-background-800/50 hover:border-primary-500/15 transition-all duration-200">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs font-medium text-foreground-600">{item.time}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-700"></span>
                    <span className={`w-6 h-6 flex items-center justify-center rounded-md ${item.iconBg}`}>
                      <i className={`${item.icon} text-xs`}></i>
                    </span>
                  </div>
                  <h3 className="font-heading text-base font-bold text-foreground-200 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}